/**
 * MealIcon — sanitized from `assets/newSvg/meal.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 * Nesting `g` translates cancelled to identity; geometry lives on the path.
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

const MEAL_PATH =
  'M6.64131,7.31329 C7.96838,7.728 9.86312,8 11.9999,8 C14.1367,8 16.0314,7.728 17.3585,7.31329 C19.0009,6.80002 19.144,6.24468 17.3585,5.68671 C16.0314,5.272 14.1367,5 11.9999,5 C9.86312,5 7.96838,5.272 6.64131,5.68671 C4.86333,6.24233 5.02303,6.80758 6.64131,7.31329 Z M11.9999,3 C9.71838,3 7.61311,3.28764 6.04476,3.77775 C4.4902,4.26355 2.71611,5.2319 3.01152,7.15206 L4.54726,17.1344 C4.88549,19.3329 6.45054,21.2947 8.79411,21.7012 C9.75598,21.868 10.8708,22 11.9999,22 C13.1289,22 14.2438,21.868 15.2057,21.7012 C17.5492,21.2947 19.1143,19.3329 19.4525,17.1344 L20.9883,7.15206 C21.2837,5.23189 19.5096,4.26356 17.955,3.77775 C16.3867,3.28764 14.2814,3 11.9999,3 Z';

export function MealIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path d={MEAL_PATH} fill={color} fillRule="evenodd" />
    </Svg>
  );
}

export default MealIcon;
